import React, { useEffect } from 'react';
import { useAuth } from '../../../context/AuthContext';
import { getUserDisplayName } from '../../../utils/userName';

const timeGreeting = () => {
  const hour = new Date().getHours();
  if (hour >= 5 && hour < 12) return 'Good morning';
  if (hour >= 12 && hour < 17) return 'Good afternoon';
  if (hour >= 17 && hour < 22) return 'Good evening';
  return 'Hello';
};

const Greeting = ({ userName: _userName }) => {
  const { normalizedUser } = useAuth();

  useEffect(() => {
    if (process.env.NODE_ENV !== 'production') {
      console.log('Dashboard user:', normalizedUser);
    }
  }, [normalizedUser]);

  const displayName = getUserDisplayName({ ...normalizedUser, fullName: normalizedUser?.fullName || _userName || '' });
  const greeting = timeGreeting();

  return (
    <div className="mb-8">
      <h1 className="text-3xl font-semibold text-notion-text tracking-tight mb-1">
        {greeting}{displayName !== 'there' ? `, ${displayName}` : ''}
      </h1>
      <p className="text-notion-text-light text-sm">
        Here is what's happening in your pipeline today.
      </p>
    </div>
  );
};

export default Greeting;
